import React from "react";
import { Link } from "react-router-dom";

const diasporaFaqs = [
  {
    question: "How can I trust the build quality if I am not there to inspect it?",
    answer: "This is our greatest advantage. We are not just a real estate marketing agency; we are the builders. Sagama Construction and Engineering directly handles the architecture, materials, and heavy engineering. By removing third-party contractors, we maintain strict quality control from the foundation to the final finish.",
  },
  {
    question: "Do I need to travel to Abuja to sign the final paperwork?",
    answer: "No. Our entire pipeline is designed for remote closing. From your initial reservation deposit to receiving your final allocation documents, everything can be securely managed and tracked online. However, we recommend having a family member or legal representative on ground.",
  },
  {
    question: "What types of properties are available for investment?",
    answer: "We develop a wide portfolio across Abuja, ranging from modern residential estates perfect for family relocation or vacation homes, to commercial properties designed for high-yield rental income.",
  },
  {
    question: "Is my financial investment safe?",
    answer: "Absolute transparency is our core commitment. Every payment you make is tracked through official banking channels and instantly reflected on your personal app dashboard. You always know exactly where your balance stands.",
  },
];

const Diaspora = () => {
  // Accordion toggle with smooth animation
  const handleAccordionClick = (e) => {
    const button = e.currentTarget;
    const wrapper = button.nextElementSibling; // the .faq-answer-wrapper is directly after the button
    if (!wrapper) return;
    const isOpen = wrapper.classList.contains('open');

    // Close all other open wrappers
    document.querySelectorAll('.faq-answer-wrapper.open').forEach(el => {
      if (el !== wrapper) {
        el.classList.remove('open');
        el.previousElementSibling.setAttribute('aria-expanded', 'false');
      }
    });

    if (!isOpen) {
      wrapper.classList.add('open');
      button.setAttribute('aria-expanded', 'true');
    } else {
      wrapper.classList.remove('open');
      button.setAttribute('aria-expanded', 'false');
    }
  };

  return (
    <>
      <style>{`
        /* ========= Hero Section – Creative Flex Layout ========= */
        .hero-section {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 5rem 2rem;
          background: linear-gradient(135deg, #f9f9f9 0%, #ffffff 100%);
          border-radius: 0 0 40px 40px;
          gap: 3rem;
          flex-wrap: wrap;
          position: relative;
          overflow: hidden;
        }
        /* Decorative background element */
        .hero-section::before {
          content: '';
          position: absolute;
          top: -50px;
          right: -50px;
          width: 200px;
          height: 200px;
          background: #e86b24;
          opacity: 0.05;
          border-radius: 50%;
          z-index: 0;
        }
        .hero-text {
          flex: 1 1 400px;
          max-width: 550px;
          position: relative;
          z-index: 1;
        }
        .hero-text h1 {
          font-size: 2.8rem;
          font-weight: 700;
          color: #0a1a3d;
          line-height: 1.2;
          margin-bottom: 1.5rem;
        }
        .hero-text h1 span {
          color: #e86b24;
          position: relative;
        }
        .hero-text h1 span::after {
          content: '';
          position: absolute;
          bottom: -4px;
          left: 0;
          width: 60px;
          height: 3px;
          background: #e86b24;
          border-radius: 2px;
        }
        .hero-text p {
          font-size: 1.15rem;
          color: #555;
          line-height: 1.8;
        }
        .hero-image {
          flex: 1 1 400px;
          max-width: 500px;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 20px 50px rgba(0,0,0,0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .hero-image:hover {
          transform: translateY(-5px);
          box-shadow: 0 25px 60px rgba(0,0,0,0.15);
        }
        .hero-image img {
          width: 100%;
          height: auto;
          display: block;
          object-fit: cover;
        }

        .content-section {
          max-width: 1000px;
          margin: 2rem auto;
          padding: 0 20px;
        }

        /* Creative card */
        .creative-card {
          background: #fff;
          border-radius: 16px;
          padding: 30px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.04);
          margin-bottom: 2rem;
          display: flex;
          align-items: center;
          gap: 20px;
          border-left: 5px solid #e86b24;
          transition: transform 0.3s, box-shadow 0.3s;
        }
        .creative-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 12px 30px rgba(0,0,0,0.08);
        }
        .creative-card .icon {
          font-size: 2.5rem;
          color: #e86b24;
          flex-shrink: 0;
        }
        .creative-card .details h3 {
          font-size: 1.5rem;
          font-weight: 600;
          color: #0a1a3d;
          margin-bottom: 0.5rem;
        }
        .creative-card .details p {
          color: #555;
          font-size: 0.95rem;
          line-height: 1.6;
        }

        /* Phase cards – icons with hover */
        .phase-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 25px;
          margin: 2rem 0;
        }
        .phase-card {
          background: #fff;
          border: 2px solid transparent;
          border-radius: 16px;
          padding: 25px 20px;
          text-align: center;
          box-shadow: 0 8px 24px rgba(0,0,0,0.04);
          transition: transform 0.3s, box-shadow 0.3s, border-color 0.3s;
        }
        .phase-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 35px rgba(0,0,0,0.1);
          border-color: #e86b24;
        }
        .phase-icon {
          font-size: 2.2rem;
          color: #e86b24;
          margin-bottom: 1rem;
          transition: transform 0.3s, color 0.3s;
        }
        .phase-card:hover .phase-icon {
          transform: scale(1.2);
          color: #d2551a;
        }
        .phase-title {
          font-size: 1.15rem;
          font-weight: 600;
          color: #0a1a3d;
          margin-bottom: 0.5rem;
        }
        .phase-desc {
          color: #555;
          font-size: 0.9rem;
          line-height: 1.6;
        }

        /* FAQ Accordion */
        .faq-container {
          background: #fff;
          border-radius: 16px;
          padding: 30px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.04);
          margin: 3rem 0;
        }
        .faq-item {
          border: 1px solid #eee;
          border-radius: 14px;
          margin-bottom: 1rem;
          overflow: hidden;
          transition: box-shadow 0.3s;
        }
        .faq-item:hover {
          box-shadow: 0 4px 15px rgba(0,0,0,0.06);
        }
        .faq-question {
          background: #fafafa;
          border: none;
          width: 100%;
          text-align: left;
          padding: 20px 25px;
          font-size: 1.05rem;
          font-weight: 600;
          color: #0a1a3d;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: background 0.3s, color 0.3s;
        }
        .faq-question:hover {
          background: #f0f0f0;
          color: #e86b24;
        }
        .faq-question[aria-expanded="true"] {
          background: #e86b24;
          color: #fff;
        }
        .faq-question .accordion-icon {
          font-size: 1.4rem;
          transition: transform 0.3s;
          flex-shrink: 0;
        }
        .faq-question[aria-expanded="true"] .accordion-icon {
          transform: rotate(45deg);
        }
        .faq-answer-wrapper {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.4s ease;
        }
        .faq-answer-wrapper.open {
          max-height: 500px;
        }
        .faq-answer {
          padding: 20px 25px;
          color: #555;
          line-height: 1.7;
          font-size: 0.95rem;
          background: #fff;
          border-top: 1px solid #eee;
        }

        .cta-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: #e86b24;
          color: #fff;
          padding: 14px 30px;
          border-radius: 50px;
          font-weight: 600;
          text-decoration: none;
          transition: background 0.3s, transform 0.2s;
        }
        .cta-btn:hover {
          background: #d2551a;
          transform: translateY(-2px);
        }

        @media (max-width: 768px) {
          .hero-section {
            flex-direction: column-reverse;
            padding: 2rem 1rem;
            gap: 2rem;
          }
          .hero-text h1 {
            font-size: 2rem;
          }
        }
      `}</style>

      {/* Hero Section – Flex Layout with creative touches */}
      <div className="hero-section">
        <div className="hero-text">
          <h1>
            <span>Invest From Anywhere:</span><br />The Sagama Diaspora System
          </h1>
          <p>Your gateway to premium real estate in Abuja, built with transparency and precision.</p>
        </div>
        <div className="hero-image">
          <img src="/assets/img/dispora.jpeg" alt="Diaspora Investment" />
        </div>
      </div>

      <div className="content-section">
        {/* Intro */}
        <div className="creative-card">
          <div className="icon"><i className="fal fa-globe-americas"></i></div>
          <div className="details">
            <h3>Invest From Anywhere</h3>
            <p>
              Investing in Nigerian real estate from abroad shouldn't feel like a gamble. We understand the anxieties of remote investment — from delayed timelines to compromised build quality.
            </p>
            <p>
              That is why we created a system specifically for our diaspora clients. By pairing the transparent, client‑centric experience of Sagama Homes with the technical mastery of Sagama Construction and Engineering, we bridge the gap between continents.
            </p>
          </div>
        </div>

        {/* Buying Journey */}
        <h2 style={{ fontSize: '2rem', fontWeight: 700, color: '#0a1a3d', marginBottom: '1.5rem', textAlign: 'center' }}>
          Your Buying Journey
        </h2>
        <p style={{ textAlign: 'center', color: '#555', marginBottom: '2rem' }}>
          We have digitized the entire property acquisition process.
        </p>
        <div className="phase-grid">
          <div className="phase-card">
            <div className="phase-icon"><i className="fal fa-desktop"></i></div>
            <div className="phase-title">Digital Discovery</div>
            <p className="phase-desc">Browse active estates online with high‑resolution images and real‑time availability.</p>
          </div>
          <div className="phase-card">
            <div className="phase-icon"><i className="fal fa-video"></i></div>
            <div className="phase-title">Virtual Consultation & Proxy Tour</div>
            <p className="phase-desc">Connect via video call and have a trusted representative visit the site.</p>
          </div>
          <div className="phase-card">
            <div className="phase-icon"><i className="fal fa-file-signature"></i></div>
            <div className="phase-title">Secure Allocation</div>
            <p className="phase-desc">Sign documents digitally and secure your chosen property from anywhere.</p>
          </div>
          <div className="phase-card">
            <div className="phase-icon"><i className="fal fa-chart-line"></i></div>
            <div className="phase-title">Track Progress & Payments</div>
            <p className="phase-desc">Follow construction updates and payment milestones in real time.</p>
          </div>
        </div>

        {/* FAQ Accordion */}
        <div className="faq-container">
          <h2 style={{ fontSize: '2rem', fontWeight: 700, color: '#0a1a3d', marginBottom: '1.5rem' }}>
            Frequently Asked Questions By Diasporans
          </h2>
          {diasporaFaqs.map((faq, idx) => (
            <div className="faq-item" key={idx}>
              <button
                className="faq-question"
                onClick={handleAccordionClick}
                aria-expanded="false"
              >
                {faq.question}
                <span className="accordion-icon">+</span>
              </button>
              <div className="faq-answer-wrapper">
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
          <p className="mt-3" style={{ fontStyle: 'italic', color: '#888' }}>
            Investor Tip: We always welcome due diligence. We encourage our diaspora buyers to have a registered Nigerian lawyer review all property documents before making an initial deposit.
          </p>
        </div>

        {/* CTA */}
        <div className="text-center mb-5">
          <Link to="/top-estates" className="cta-btn">
            View Top Estates <i className="fas fa-arrow-right ms-2"></i>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Diaspora;